import * as React from 'react';

// import { useRibbonSplitButtonClasses } from '../../RibbonButton/next/useRibbonButtonClasses';
import { RibbonSplitButtonInternalProps } from '../RibbonSplitButton';
// import { useRibbonSplitButton } from './useRibbonSplitButton';

/**
 * Define a styled `RibbonSplitButton` using the `useRibbonSplitButton` hook.
 */
export const RibbonSplitButton = React.memo(
  // Task 5348034: Upgrade FlyoutAnchor/SplitButton to latest converged version
  React.forwardRef<HTMLElement, RibbonSplitButtonInternalProps>((/*props, ref*/) => {
    // const state = useRibbonSplitButton(props, ref);

    // useRibbonSplitButtonClasses(state);

    // return renderSplitButton(state);
    return null;
  })
);

RibbonSplitButton.displayName = 'next/RibbonSplitButton';
